// extracted by mini-css-extract-plugin
module.exports = {"colorPicker":"task-color-picker_colorPicker__Cz5_h","colorCircleCell":"task-color-picker_colorCircleCell__cMZTB","colorCircle":"task-color-picker_colorCircle__bntQr"};